#!/usr/bin/env node

import { spawn } from 'child_process';
import { readFileSync } from 'fs';

const node = 'node',
	bin = __dirname + '/workspace.js',
	timeout = 1000,
	args = process.argv.slice(2);

let startTime: number;

try {
	const config = JSON.parse(
		readFileSync(process.cwd() + '/workspace.json', 'utf8')
	);
	if (config.debug) args.push(`--inspect=${config['debug.port'] || '9005'}`);
} catch (e) {
	console.log(e);
}
args.push(bin);
start();

function onExit(code: number) {
	if (code !== 0 && Date.now() - startTime > timeout) {
		console.log(`Received signal ${code}. Attempting restart...`);
		start();
	}
}

function start() {
	startTime = Date.now();

	const c = spawn(node, args, {
		stdio: 'inherit',
	});

	c.on('exit', onExit);
}
